import { Configurator } from "../Configurator";
import { Sections } from "../Configurator/Mutators/Sections";
import { Gallery } from "../Configurator/Mutators/Gallery";
import { SELECTORS } from "../Configurator/Constants";
import { Variant } from "../../../Interfaces/Product";
import { ConfigOption } from "../Configurator/ConfigOption";

export class RentalConfigurator extends Configurator {
    constructor(public node: HTMLElement) {
        super(node);
        this.node = node;
        this.sections = new Sections(this.node);
        this.gallery = new Gallery(this.node);
        this.variants = JSON.parse(this.node.dataset.variants);
    }

    protected handleChange(e: CustomEvent): void {
        const validValues = this.getValidVariantOptionValues(e.detail as ConfigOption);
        const initiator = e.detail.name;
        this.updateOptions(validValues, initiator);
        const variant = this.selectedVariant;
        this.mutate(variant);
    }

    /**
     * call mutators
     * @param v
     * @private
     */
    protected mutate(v: Variant) {
        this.sections.update(v).then(/* ignore promise */);
    }

    get selectedVariant(): Variant {
        const selection = this.selection;
        return this.variants.find((variant) => {
            return variant.option1 === (selection.option1 || null);
        });
    }
}

const configurator = document.querySelector<HTMLElement>(SELECTORS.CONFIGURATOR_RENTAL);
let instance: RentalConfigurator = null;
if (configurator) {
    instance = new RentalConfigurator(configurator);
}

export default instance;
